export default __webpack_public_path__ + "static/media/cyan.724d059d.svg";